import { useState, useEffect } from "react";

export const useGetDimensions = (classname, pos) => {
  const ele = document.getElementsByClassName(classname)
  const obj = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0, x: 0, y: 0 }
  const [dimension, setDimension] = useState(obj);
  function handleWindowSizeChange() {
    setDimension(ele[pos]?.getBoundingClientRect());
  }
  useEffect(() => {
    setDimension(ele[pos]?.getBoundingClientRect());
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  if (ele.length === 0) return obj
  const { top, right, bottom, left, width, height, x, y } = dimension
  return { top, right, bottom, left, width, height, x, y }
};